import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Slide extends Component {
  constructor(props) {
    super(props);

  }


  render() {
    const { image, visible, description, url } = this.props;
    const slideStyle = {
      width: 1200,
      height: 500,
      display: visible
    };
    const imageStyle = {
      width: 1200,
      height: 400,
      backgroundImage: `url(images/tiles/thumbs/${image}.png)`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '100% 100%',
      display: visible
    };
    const descriptionStyle={
      fontSize: "2rem",
      textDecoration: "none",
      textAlign: "center",
      color: "#f18904",
    }

    return (
      <Link to={url}>
        <div style={slideStyle}>
          <div style={descriptionStyle}>{description}</div>
          <div style={imageStyle}></div>
        </div>
      </Link>
    )

  }
}

export default Slide


// WEBPACK FOOTER //
// ./src/components/slider/Slide.jsx